import {
  type BoxProps,
  LightModeSemanticColors,
  fontSizes,
} from '@enechain/ecloud-designsystem'

/**
 * 会員情報 / 料金・手数料の 2 セクションで共有する読み取り専用テーブルの見た目。
 *
 * 行数が固定 (会員情報 1 行 / 料金 3 行) で操作列も無いため、
 * `MasterDataTable` (フィルタ・sticky 操作列・行アクション込み) は使わず
 * DS の table primitive をそのまま使う。 token は `MasterDataTable` と同じ
 * ものを引き、 見出し背景・境界線が他のマスタ画面と揃うようにする。
 */
/**
 * 表の外枠 = design `.ecl-table-wrap` (枠 1px `Border.lowEmphasis`・角丸 lg・横スクロール。
 * UI 辞書 `components/table.md` §0。 8080 `admin/eslj-accounts.html` も 2 表とも wrap で包む)。
 */
export const tableWrapProps: BoxProps = {
  overflowX: 'auto',
  borderWidth: '1px',
  borderColor: 'Border.lowEmphasis',
  borderRadius: 'lg',
  background: 'Surface.primary',
}

/**
 * 最終行の下線は外枠と重なって 2 本に見えるので消す (table.md §0「table-wrap の枠線と
 * セル外周枠線の二重化に注意」)。 下線は Chakra の table recipe (variant line) が付ける。
 */
export const tableRootCss = {
  '& tbody tr:last-of-type td': { borderBottomWidth: 0 },
}

export const tableHeaderCellStyle: React.CSSProperties = {
  position: 'sticky',
  top: 0,
  background: LightModeSemanticColors.Surface.tableHeader.value,
  fontWeight: 600,
  fontSize: fontSizes.md.value,
  borderBottom: `1px solid ${LightModeSemanticColors.Border.lowEmphasis.value}`,
  whiteSpace: 'nowrap',
  textTransform: 'none',
  letterSpacing: 'normal',
  color: LightModeSemanticColors.Text.midEmphasis.value,
}

/** TD の余白は共通 table recipe (size md) が持つ。 */
export const tableCellStyle: React.CSSProperties = {
  fontSize: fontSizes.md.value,
  whiteSpace: 'nowrap',
  verticalAlign: 'middle',
}

/** 単価列は右寄せ + 等幅数字 (桁を目で揃えるため)。 */
export const numericCellStyle: React.CSSProperties = {
  ...tableCellStyle,
  textAlign: 'right',
  fontVariantNumeric: 'tabular-nums',
}

/**
 * 数値列の TH。 TD と同じく右寄せ (UI 辞書 `components/table.md`「列揃えの規約」
 * = 数値は right、 TH も合わせる。 8080 `admin/eslj-accounts.html` の `th.col-num`)。
 */
export const numericHeaderCellStyle: React.CSSProperties = {
  ...tableHeaderCellStyle,
  textAlign: 'right',
}
